import type { App, Plugin } from 'vue'

export const gameNamePlugin: Plugin = {
  install(app: App): void {
    app.config.globalProperties.$gameName = window.gameName
  },
}
